import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { RouterModule, Routes } from "@angular/router";
//import { Angular2CsvModule } from 'angular2-csv/Angular2-csv';

import { AppComponent } from "./app.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { LoginComponent } from "./components/login/login.component";
import { SuscribeComponent } from "./components/suscribe/suscribe.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ProfileComponent } from "./components/profile/profile.component";
import { HomeComponent } from "./components/home/home.component";

import { ValidateService } from "./services/validate.service";
import { AuthService } from "./services/auth.service";
import { FlashMessagesModule } from "angular2-flash-messages";
import { AuthGuard } from "./guards/auth.guard";
import { CancelComponent } from "./cancel/cancel.component";

const appRoutes: Routes = [
  { path: "privacy", component: HomeComponent },
  { path: "suscribe", component: SuscribeComponent },
  { path: "", component: LoginComponent },
  { path: "admin", component: DashboardComponent },
  { path: "profile", component: ProfileComponent },
  { path: "cancel", component: CancelComponent },
  { path: "**", redirectTo: "/" },

  //, canActivate:[AuthGuard]
];

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    LoginComponent,
    SuscribeComponent,
    DashboardComponent,
    ProfileComponent,
    HomeComponent,
    CancelComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes),
    FlashMessagesModule,
    //Angular2CsvModule
  ],
  providers: [ValidateService, AuthService, AuthGuard],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts